<template>
  <div class="ui tab segment" data-tab="room">
    <table class="ui celled striped table">
      <tbody>
        <tr v-for="(form, i) in roomForms" :key="i">
          <td>
            <form class="ui form" :class="{'warning': form.hasErrors()}">
              <div class="fields">
                <div class="required sixteen wide field">
                  <label>会場名</label>
                  <input type="text" v-model="form.model.name">
                  <validation-message :form="form" :field="'name'"></validation-message>
                </div>
              </div>
              <div class="fields">
                <div class="required sixteen wide field">
                  <label>会場詳細</label>
                  <textarea v-model="form.model.details" rows="2"></textarea>
                  <validation-message :form="form" :field="'details'"></validation-message>
                </div>
              </div>
              <div class="fields">
                <div class="required sixteen wide field">
                  <label>最低保証料金</label>
                  <textarea v-model="form.model.min_guarantee_price" rows="2"></textarea>
                  <validation-message :form="form" :field="'min_guarantee_price'"></validation-message>
                </div>
              </div>
              <div class="required field">
                <label>利用用途</label>
                <div class="ui checkbox">
                  <input v-model="form.model.is_banquet" type="checkbox" value="true">
                  <label>宴会</label>
                </div>
                <div class="ui checkbox">
                  <input v-model="form.model.is_meeting" type="checkbox" value="true">
                  <label>会議室</label>
                </div>
                <validation-message :form="form" :field="'usage_purposes'"></validation-message>
              </div>
              <div class="fields">
                <div class="required eight wide field">
                  <label>会場イメージ1</label>
                  <s3 v-model="form.model.image1"></s3>
                  <validation-message :form="form" :field="'image1'"></validation-message>
                </div>
                <div class="eight wide field">
                  <label>会場イメージ2</label>
                  <s3 v-model="form.model.image2"></s3>
                  <validation-message :form="form" :field="'image2'"></validation-message>
                </div>
              </div>
              <div class="fields">
                <div class="required four wide field">
                  <label>会場タイプ</label>
                  <dropdown v-model="form.model.room_type" :options="consts.ROOM_TYPE" @change="onChangeRoomType(form)"></dropdown>
                  <validation-message :form="form" :field="'room_type'"></validation-message>
                </div>
                <div class="required four wide field">
                  <label>座席</label>
                  <dropdown v-if="form.model.room_type === 1" v-model="form.model.seat_type" :placeholder="'座席'">
                    <option value="1">テーブル</option>
                    <option value="2">お座敷</option>
                    <option value="3">掘りごたつ</option>
                    <option value="9">ソファー・その他</option>
                  </dropdown>
                  <dropdown v-else-if="form.model.room_type === 2" v-model="form.model.seat_type" :placeholder="'座席'">
                    <option v-if="model.shop_type !== 4 && model.shop_type !== 5" value="1">テーブル</option>
                    <option v-if="model.shop_type !== 4 && model.shop_type !== 5" value="9">ソファー・その他</option>
                    <option v-if="model.shop_type === 4 || model.shop_type === 5" value="4">和室</option>
                    <option v-if="model.shop_type === 4 || model.shop_type === 5" value="5">洋室</option>
                  </dropdown>
                  <dropdown v-else-if="form.model.room_type === 3" v-model="form.model.seat_type" :placeholder="'座席'">
                    <option value="1">テーブル</option>
                    <option value="9">ソファー・その他</option>
                  </dropdown>
                  <validation-message :form="form" :field="'seat_type'"></validation-message>
                </div>
                <div v-show="form.model.room_type === 1" class="required four wide field">
                  <label>個室タイプ</label>
                  <dropdown v-model="form.model.private_room_type" :options="consts.PRIVATE_ROOM_TYPE" :placeholder="'個室タイプ'"></dropdown>
                  <validation-message :form="form" :field="'private_room_type'"></validation-message>
                </div>
                <div v-show="form.model.room_type === 1" class="required four wide field">
                  <label>部屋数</label>
                  <input type="number" v-model="form.model.room_count">
                  <validation-message :form="form" :field="'room_count'"></validation-message>
                </div>
              </div>
              <div class="fields">
                <div class="two wide field">
                  <label>天井高(m)</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.ceiling_height">
                    <label class="ui label">m</label>
                  </div>
                  <validation-message :form="form" :field="'ceiling_height'"></validation-message>
                </div>
                <div class="two wide field">
                  <label>面積(m²)</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.area">
                    <label class="ui label">m²</label>
                  </div>
                  <validation-message :form="form" :field="'area'"></validation-message>
                </div>
              </div>
              <div class="fields">
                <div class="two wide field">
                  <label>着席最小</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.min_seat_count">
                    <label class="ui label">人</label>
                  </div>
                  <validation-message :form="form" :field="'min_seat_count'"></validation-message>
                </div>
                <div class="two wide field">
                  <label>着席最大</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.max_seat_count">
                    <label class="ui label">人</label>
                  </div>
                  <validation-message :form="form" :field="'max_seat_count'"></validation-message>
                </div>
                <div class="two wide field">
                  <label>立席最小</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.min_standing_count">
                    <label class="ui label">人</label>
                  </div>
                  <validation-message :form="form" :field="'min_standing_count'"></validation-message>
                </div>
                <div class="two wide field">
                  <label>立席最大</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.max_standing_count">
                    <label class="ui label">人</label>
                  </div>
                  <validation-message :form="form" :field="'max_standing_count'"></validation-message>
                </div>
              </div>
              <div class="fields">
                <div class="two wide field">
                  <label>スクール最小</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.min_school">
                    <label class="ui label">人</label>
                  </div>
                  <validation-message :form="form" :field="'min_school'"></validation-message>
                </div>
                <div class="two wide field">
                  <label>スクール最大</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.max_school">
                    <label class="ui label">人</label>
                  </div>
                  <validation-message :form="form" :field="'max_school'"></validation-message>
                </div>
                <div class="two wide field">
                  <label>シアター最小</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.min_theater">
                    <label class="ui label">人</label>
                  </div>
                  <validation-message :form="form" :field="'min_theater'"></validation-message>
                </div>
                <div class="two wide field">
                  <label>シアター最大</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.max_theater">
                    <label class="ui label">人</label>
                  </div>
                  <validation-message :form="form" :field="'max_theater'"></validation-message>
                </div>
                <div class="two wide field">
                  <label>口の字最小</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.min_hollow_square">
                    <label class="ui label">人</label>
                  </div>
                  <validation-message :form="form" :field="'min_hollow_square'"></validation-message>
                </div>
                <div class="two wide field">
                  <label>口の字最大</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.max_hollow_square">
                    <label class="ui label">人</label>
                  </div>
                  <validation-message :form="form" :field="'max_hollow_square'"></validation-message>
                </div>
                <div class="two wide field">
                  <label>島型最小</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.min_island">
                    <label class="ui label">人</label>
                  </div>
                  <validation-message :form="form" :field="'min_island'"></validation-message>
                </div>
                <div class="two wide field">
                  <label>島型最大</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.max_island">
                    <label class="ui label">人</label>
                  </div>
                  <validation-message :form="form" :field="'max_island'"></validation-message>
                </div>
              </div>
              <div class="fields">
                <div class="two wide field">
                  <label>対面最小</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.min_facing">
                    <label class="ui label">人</label>
                  </div>
                  <validation-message :form="form" :field="'min_facing'"></validation-message>
                </div>
                <div class="two wide field">
                  <label>対面最大</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.max_facing">
                    <label class="ui label">人</label>
                  </div>
                  <validation-message :form="form" :field="'max_facing'"></validation-message>
                </div>
                <div class="two wide field">
                  <label>コの字最小</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.min_u_shape">
                    <label class="ui label">人</label>
                  </div>
                  <validation-message :form="form" :field="'min_u_shape'"></validation-message>
                </div>
                <div class="two wide field">
                  <label>コの字最大</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.max_u_shape">
                    <label class="ui label">人</label>
                  </div>
                  <validation-message :form="form" :field="'max_u_shape'"></validation-message>
                </div>
                <div class="four wide field">
                  <label>会議利用料金目安（1時間あたり）最小</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.min_meeting_price">
                    <label class="ui label">円</label>
                  </div>
                  <validation-message :form="form" :field="'min_meeting_price'"></validation-message>
                </div>
                <div class="four wide field">
                  <label>会議利用料金目安（1時間あたり）最大</label>
                  <div class="ui right labeled input">
                    <input type="number" v-model="form.model.max_meeting_price">
                    <label class="ui label">円</label>
                  </div>
                  <validation-message :form="form" :field="'max_meeting_price'"></validation-message>
                </div>
              </div>
            </form>
          </td>
          <td class="actions">
            <button type="button" class="ui tiny positive button" @click="saveRoom(form)">保存</button>
            <button type="button" class="ui tiny red button" @click="deleteRoom(form, i)">削除</button>
          </td>
        </tr>
      </tbody>
      <tfoot class="full-width">
        <th colspan="2">
          <div class="ui center aligned">
            <i class="clickable plus green large icon" @click="newRoom()"></i>
          </div>
        </th>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
    data: function() {
        return {
            model: {},
            roomForms: [],
            form: this.createForm(),
        };
    },
    methods: {
        initialize: function(model) {
            this.model = model;
            _.forEach(model.rooms, function(each) {
                this.roomForms.push(this.createForm(each));
            }.bind(this));
        },
        onChangeRoomType: function(form) {
            form.model.seat_type = null;
        },
        newRoom: function() {
            this.roomForms.push(this.createForm({
                room_type: 1,
                seat_type: 1,
                room_count: null,
            }));
        },
        saveRoom: function(form) {
            if (form.model.room_type !== 1) {
                form.model.private_room_type = null;
                form.model.room_count = null;
            }
            // TODO: dropdown を clear したタイミングでフィールド自体が消えてしまう
            form.model.private_room_type = form.model.private_room_type || null;
            if (form.model.id) {
                form.put(form.model.edit_api_url, function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            } else {
                form.post(this.model.new_room_api_url, function(response) {
                    this.merge(form.model, response.data);
                    alert('保存しました');
                });
            }
        },
        deleteRoom: function(form, i) {
            if (!form.model.id) {
                this.roomForms.splice(i, 1);
                return;
            }
            if (!confirm('削除します。よろしいですか？')) {
                return;
            }
            form.delete(form.model.edit_api_url, function() {
                this.roomForms.splice(i, 1);
            }.bind(this));
        },
    }
};
</script>
